import React from 'react';

const UAEMap = () => {
  return (
    <div className=' w-full mt-5 mb-5'>
      <iframe className=' w-[100%] m-auto h-[300px] sm:h-[450px] '
        title="United Arab Emirates Map"
        loading="lazy"
        allowFullScreen
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5866142.167765116!2d51.286984537853854!3d23.905649532988534!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f4343d3e94b29%3A0x2022a62e58a1c53b!2sUnited%20Arab%20Emirates!5e0!3m2!1sen!2sus!4v1646997782997!5m2!1sen!2sus"
      ></iframe>
    </div>
  );
};

export default UAEMap;
